import { useState } from "react"
import { BrowserRouter as Router } from "react-router-dom"
import "../src/assets/scss/style.scss"
import {
  BASENAME,
  SITE_HEADER_TEXT,
  SITE_HEADER_TEXT_COLOR,
  SITE_PRIMARY_COLOR,
  SITE_TITLE,
} from "./config/constant"
import ThemeContext from "./context/ThemeContext"
import { getCustomTheme } from "./hooks/useTheme"
import routes, { renderRoutes } from "./routes"

function App() {
  const customTheme = getCustomTheme()
  const [theme, setTheme] = useState({
    headerTextColor: customTheme?.headerTextColor || SITE_HEADER_TEXT_COLOR,
    primaryColor: customTheme?.primaryColor || SITE_PRIMARY_COLOR,
    customStyles: customTheme?.customStyles || null,
    headerText: customTheme?.headerText || SITE_HEADER_TEXT,
    title: customTheme?.title || SITE_TITLE,
  })

  const initialValue = {
    theme,
    setTheme,
  }

  return (
    <>
      <ThemeContext.Provider value={initialValue}>
        <Router basename={BASENAME}>{renderRoutes(routes())}</Router>
      </ThemeContext.Provider>
    </>
  )
}

export default App
